import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export const screenFieldsGeneral: GenericFormItem[] = [
  {
    gridXs: 6,
    label: 'BASE_NAME_KEY',
    stateKey: 'name',
  },
  {
    gridXs: 6,
    label: 'DESCRIPTION_KEY',
    stateKey: 'description',
  },
];

export const screenFieldsMonitoring: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'CONNECTION_MAX_KEY',
    stateKey: 'connection_max',
    type: 'number',
    validateOnChange: true,
  },
];

export const screenFieldsReference: GenericFormItem[] = [
  {
    gridXs: 6,
    label: 'EMPTY_KEY',
    stateKey: 'temperature_empty',
    type: 'number',
    validateOnChange: true,
  },
  {
    gridXs: 6,
    label: 'TURNED_OFF_KEY',
    stateKey: 'temperature_stopped',
    type: 'number',
    validateOnChange: true,
  },
  {
    gridXs: 6,
    label: 'OPERATIONAL_KEY',
    stateKey: 'temperature_operational',
    type: 'number',
    validateOnChange: true,
  },
  {
    gridXs: 6,
    label: 'TOP_KEY',
    stateKey: 'temperature_top',
    type: 'number',
    disabled: true,
    validateOnChange: true,
  },
];

export const screenFieldsOthers: GenericFormItem[] = [
  {
    gridXs: 6,
    label: 'BOOT_TIME_KEY',
    stateKey: 'boot_time',
    type: 'number',
  },
];
